import {createReducer, on} from "@ngrx/store";
import {setLanguage} from "@app/store";

export const languageFeatureKey = 'language';

export interface ILanguageState {
  language: string;
}

export const initialState: ILanguageState = {
  language: 'ru',
};

export const languageReducer = createReducer(
  initialState,
  on(setLanguage, (state, {language}) => ({...state, language}))
);
